import { cloneDeep } from 'lodash';
// 检测是否是一个数组
function isArray(state) {
  return Array.isArray(state);
}

// 数组转join
export function useJoin(state) {
  return isArray(state) ? state.join(',') : state;
}

/**
 * 获取请求前的参数
 */
export function getBeforeRequestParams({ searchModel }) {
  // 获取 search 参数
  const searchParams = handleSearchParams(searchModel);
  // 获取 状态 参数
  const statusParams = handleStatusParams(searchModel);
  // 获取 表格表头 参数
  const headersParams = handleTableHeadersParams(searchModel);

  const params = {
    ...searchParams,
    ...statusParams,
    ...headersParams,
  }

  // 异常字段若有且只有一个库存不足异常，需要传订单类型-分销订单
  if (params.exceptionStatus) {
    const excepArr = params.exceptionStatus.split(',');
    if (excepArr.length === 1 && excepArr.includes('EXCEP_STOCK_INSUFFICIENT')) {
      const tradeTypeArr =  params.tradeType ? params.tradeType.split(',') : [];
      if (!tradeTypeArr.includes('75')) {
        tradeTypeArr.push('75')
      }
      params.tradeType = tradeTypeArr.join(',');
    }
  }

  // 如果关键字搜索是 收货地区，需要提出来，并删除关键字相关字段
  if (searchModel.key === 'receiverArea') {
    params.receiverArea = searchModel.text;
    delete params.key;
    delete params.text;
  }

  return params;
}

/**
 * 获取 search 参数
 * @param {*} searchModel
 * @returns Object<*>
 */
function handleSearchParams(searchModel) {
  const { userId, secondUserId, sellerNicks, subSources, sourceId, expressCompanyIds = [], destId, customTime = {} } = searchModel;

  // 默认参数
  const params = {
    isExcep: searchModel.isExcep, // 是否需要包含异常的数据
    queryId: searchModel.queryId, // 接口请求的 请求id
    needOrder: searchModel.needOrder || 1, // 查询商品
    sid: searchModel.sid, // 系统订单号
    tid: searchModel.tid, // 平台交易号
    buyerNickType: searchModel.buyerNickType || 1,
    buyerNick: searchModel.buyerNick, //买家昵称
    outSid: searchModel.outSid, // 快递单号
    key: searchModel.key || 'itemTitle', // 快捷查询类型
    queryType: searchModel.queryType || 0, // 0模糊查询 | 1精确查询
    text: searchModel.text || '', // 文本内容
    // 数组格式类处理
    userId: useJoin(userId), // 店铺名称
    secondUserId: useJoin(secondUserId), // 奇门子店铺所需参数
    sellerNicks: useJoin(sellerNicks), // 奇门子店铺所需参数
    subSources: useJoin(subSources), // 奇门子店铺所需参数
    destId: useJoin(destId), // 供销商
    sourceId: useJoin(sourceId), // 分销商
    expressCompanyIds: useJoin(expressCompanyIds), // 快递公司
    needAllocateStock: 1, // 库存
  };

  // 时间
  const { select = 'pay_time', start = '', end = '' } = customTime;
  params.timeType = select;
  params.field = select;
  params.startTime = start;
  params.endTime = end;

  // 规格
  if (searchModel.key === 'itemTitle') {
    params.skuProp = searchModel.skuProp;
  }
  if (searchModel.key === 'platFormTitle') {
    params.platSkuProp = searchModel.platSkuProp;
  }
  if (searchModel.key === 'platSkuProps') {
    params.itemTitle = searchModel.itemTitle;
  }
  // 不限制
  if (searchModel.key === 'outerId') {
    params.itemType = searchModel.itemType;
  }

  return params;
}

/**
 * 获取 状态 参数
 * @param {*} searchModel
 * @returns Object<*>
 */
function handleStatusParams(searchModel) {
  const params = {};
  const { expressStatus = '', logisticsWarningParams } = searchModel;

  // 状态 || 异常
  ['exceptionStatus', 'exceptIds'].forEach(key => {
    if (searchModel[key]?.length > 0) {
      params[key] = useJoin(searchModel[key]);
    }
  });

  // 如果 待审核 和 待推送 同时存在 则删除掉 待推送
  ['sysStatus'].forEach(key => {
    if (searchModel[key]?.length > 0) {
      const newList = cloneDeep(searchModel[key]);
      if (newList.includes('WAIT_AUDIT_75')) {
        newList.push('WAIT_AUDIT');
      }
      let list = Array.from(new Set(newList.filter(item => item != 'WAIT_AUDIT_75')));
      params[key] = useJoin(list);
    }
  });

  // 处理异常，若有上传异常EX_UPLOAD_DELIVER时
  // 需带上系统状态WAIT_BUYER_PAY,WAIT_AUDIT,WAIT_FINANCE_AUDIT,FINISHED_AUDIT,SELLER_SEND_GOODS,FINISHED,CLOSED
  if (searchModel.exceptionStatus?.includes('EX_UPLOAD_DELIVER')) {
    const newStatus = ['WAIT_BUYER_PAY', 'WAIT_AUDIT', 'WAIT_FINANCE_AUDIT', 'FINISHED_AUDIT', 'SELLER_SEND_GOODS', 'FINISHED', 'CLOSED'];
    if (params.sysStatus) {
      const statusList = params.sysStatus.split(',');
      const uniqueStatusSet = new Set([...statusList, ...newStatus]);
      params.sysStatus = Array.from(uniqueStatusSet).join(',');
    } else {
      params.sysStatus = newStatus.join(',');
    }
  }

  // 这里需要判断不为空  因为值为 1 和 0
  if (expressStatus === 'all') {
    params.expressStatus = '';
  } else if (expressStatus !== '') {
    params.expressStatus = expressStatus;
  }

  params.logisticsWarningParams = logisticsWarningParams;

  return params;
}

/**
 * 获取 表格表头 参数
 * 是由于选择了才会添加  不选择数据是不会添加的
 * @param {*} searchModel
 * @returns Object<*>
 */
function handleTableHeadersParams(searchModel) {
  let params = {};

  // 处理 平台拆单
  params = handleTradeTypeNewParamsStr(searchModel);

  ['sellerFlag', 'excludeSellerFlags', 'express', 'tradeType', 'excludeTradeType', 'tagIds'].forEach(key => {
    let list = searchModel[key];
    // 如果有长度 说明就是有值
    if (list?.length > 0) {
      // 平台拆单
      if (['tradeType', 'excludeTradeType'].includes(key)) {
        list = list.filter(item => item !== 66);
      }
      params[key] = useJoin(list);
    }
  });
  ['itemOrder', 'order', 'hasSellerMemo'].forEach(key => {
    // 如果有长度 说明就是有值
    if (searchModel[key] !== '') {
      if (key === 'order') {
        const orderArr = searchModel[key].split('&&')
        if (orderArr.length > 1) {
          const [_field, _order] = orderArr;
          params.field = _field === "RemainTime" ? 'timeout_action_time' : _field;
          params.order = _order;
        } else {
          params[key] = useJoin(searchModel[key]);
        }
      } else {
        params[key] = useJoin(searchModel[key]);
      }
    }
  });
  [
    'itemCountStart',
    'hasBuyerMessage',
    'itemCountEnd',
    'itemKindStart',
    'containOutSid',
    'itemKindEnd',
    'paymentLowerLimit',
    'paymentUpperLimit',
  ].forEach(key => {
    // 如果有长度 说明就是有值
    if (searchModel[key] !== '') {
      params[key] = searchModel[key];
    }
  });

  const selfSendOrNot = searchModel.selfSendOrNot;
  if (selfSendOrNot) {
    if (selfSendOrNot === 'notSelf') {
      if (params.tradeType) {
        params.tradeType = Array.from(new Set(['33', '48', ...params.tradeType.split(',')])).join(',');
      } else {
        params.tradeType = '33,48';
      }
    } else if (selfSendOrNot === 'gxOrder') {
      if (params.tradeType) {
        params.tradeType = Array.from(new Set(['34', ...params.tradeType.split(',')])).join(',');
      } else {
        params.tradeType = '34';
      }
    } else {
      if (params.excludeTradeType) {
        params.excludeTradeType = Array.from(new Set(['33', '48', ...params.excludeTradeType.split(',')])).join(',');
      } else {
        params.excludeTradeType = '33,48';
      }
    }
  }

  // 参数返回
  return params;
}

// 平台拆单
function handleTradeTypeNewParamsStr(searchModel) {
  const params = {};
  const { tradeType, excludeTradeType } = searchModel;

  if (tradeType.length && tradeType.includes(66)) {
    params.tradeTypeNewParamsStr = JSON.stringify({ containTypeIds: [66] });
  }

  if (excludeTradeType.length && excludeTradeType.includes(66)) {
    params.tradeTypeNewParamsStr = JSON.stringify({ containTypeIds: [66] });
  }

  return params;
}

export function handleStatusSearchDistributionOrder(searchModel, sysStatusMap) {
  const { WAIT_AUDIT_75, WAIT_AUDIT } = sysStatusMap;
  // const { tradeType, excludeTradeType } = searchModel;
  const allList = []; //[...tradeType, ...excludeTradeType];

  let params = {
    tradeType: [],
    excludeTradeType: [],
  };

  // 只勾选 待审核
  if (!WAIT_AUDIT_75 && WAIT_AUDIT) {
    console.log('待审核');
    params = {
      tradeType: [],
      excludeTradeType: [75, 48, ...allList],
    };
  }

  // 只勾选 待推送
  if (WAIT_AUDIT_75 && !WAIT_AUDIT) {
    console.log('待推送');
    params = {
      tradeType: [75, 48, ...allList],
      excludeTradeType: [],
    };
  }

  // 即勾选 待审核 又 待推送
  if (WAIT_AUDIT_75 && WAIT_AUDIT) {
    console.log('待审核 又 待推送');
    params = {
      tradeType: [],
      excludeTradeType: [],
    };
  }

  if (!WAIT_AUDIT_75 && !WAIT_AUDIT) {
    searchModel.isExcep = 2
  } else {
    searchModel.isExcep = 0
  }

  if (Number(searchModel.queryId) === 21) {
    searchModel.isExcep = 0
  }

  params = {
    tradeType: Array.from(new Set(params.tradeType)),
    excludeTradeType: Array.from(new Set(params.excludeTradeType)),
  };

  searchModel.tradeType = params.tradeType;
  searchModel.excludeTradeType = params.excludeTradeType;
}